<app-tab-navigation-header title="Role" [detail]="this.role.name" i18n-title="@@roleDetail-roleNameTitle">
	<mat-tab-group appQueryStringTabGroup>
		<mat-tab label="Capabilities" i18n-label="@@role-detailCapabilities" data-automation-id="capabilities-tab">
			<ng-template matTabContent>
				<app-role-detail-capabilities-table
					[appBreadcrumbLabel]="capabilityTableBreadcrumbLabel"
					[role]="role"
					[companyId]="companyId"
					[companyType]="company?.companyType"
					[systemCapabilityItems]="systemCapabilityItems"
				>
				</app-role-detail-capabilities-table>
			</ng-template>
		</mat-tab>
		<mat-tab label="Users" i18n-label="@@rolet-detailUsers" data-automation-id="users-tab">
			<ng-template matTabContent>
				<app-role-detail-user-table
					[appBreadcrumbLabel]="userTableBreadcrumbLabel"
					[role]="role"
					[companyId]="companyId"
					[company]="company"
				>
				</app-role-detail-user-table>
			</ng-template>
		</mat-tab>

		@if (this.canAccessAuditLogs) {
			<mat-tab label="Audit Log" i18n-label="@@role-detailsAuditLog" data-automation-id="audit-log-tab">
				<ng-template matTabContent>
					<app-audit-log-list
						[roleId]="roleId"
						[appBreadcrumbLabel]="auditLogBreadcrumbLabel"
						[hiddenColumns]="hiddenAuditLogColumns"
					></app-audit-log-list>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</app-tab-navigation-header>
